import styles from '../../styles';
import { type ThemeProps } from '../../FlowProps';

/**
 * logo to be displayed on the top of the login flow cards
 * @param {ThemeProps} props  theme props
 * @returns {Element} logo element
 */
export const CardLogo = (props: ThemeProps) =>
    props.cardLogo ? <div sx={styles.cardLogo}>{props.cardLogo}</div> : <></>;
